import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import "react-multi-date-picker/styles/layouts/mobile.css"
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'react-international-phone/style.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './Helpers/Components/ChartConfig'
import "./Assets/css/style.css"
import './Assets/css/responsive.css'
import { Provider } from 'react-redux';
import { persistor, store } from './Store';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
        <App />
    </PersistGate>
</Provider>);
